export const getRemotesConfiguration = () => window.GEM_REMOTES_CONFIGURATION?.remotes;
